import { useEffect, useState } from 'react';
import { RiskByYearMonthDistrict } from '../../../types/types';

interface UseAreaRiskDataResult {
  riskByYearMonthDistrict: RiskByYearMonthDistrict | null;
  loading: boolean;
  error: string | null;
}

/**
 * Fetches the district risk snapshot on mount ā€” same shape as
 * useEvictionsData. NEEDS CONFIRMATION: the endpoint path below is a
 * placeholder guess; swap it for the real route this data actually
 * comes from.
 */
export function useAreaRiskData(): UseAreaRiskDataResult {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const [riskByYearMonthDistrict, setRiskByYearMonthDistrict] =
    useState<RiskByYearMonthDistrict | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRiskData = async () => {
      try {
        setLoading(true);
        setError(null);

        const res = await fetch(`${BASE_URL}/prod-risk-mapper/`); // TODO: confirm real path
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }

        const data = await res.json();
        setRiskByYearMonthDistrict(data.riskByYearMonthDistrict);
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err.message : 'Failed to load data');
      } finally {
        setLoading(false);
      }
    };

    fetchRiskData();
  }, []);

  return { riskByYearMonthDistrict, loading, error };
}